/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { UserName } from './UserName';

export type CaseStatusLog = {
    case: number;
    readonly author?: UserName;
    /**
     * previous workflow status of the case
     */
    status: CaseStatusLog.status;
    /**
     * status change reason, if known
     */
    reason?: string | null;
    readonly created_at?: string;
    removed_at?: string | null;
    /**
     * estimated time that the status should be moved forward, if status is non-final
     */
    expected_next_status_by?: string | null;
}

export namespace CaseStatusLog {

    /**
     * previous workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }


}
